/**
 * A phone number the way somebody would read it aloud.
 *
 * Only reshapes what it recognises as a North American number - ten digits, or
 * eleven starting with 1. Anything else is returned exactly as it arrived,
 * because a number this app cannot parse is still the number somebody has to
 * ring, and a mangled one is worse than an unformatted one.
 *
 * Formatting happens on the way out only. What gets stored is what was typed or
 * what the app that raised the room sent, so the record never disagrees with
 * what somebody actually wrote down.
 */
export function formatPhone(raw: string | null | undefined): string {
  if (!raw) return '';
  const digits = raw.replace(/\D/g, '');
  const ten = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (ten.length !== 10) return raw;
  return `(${ten.slice(0, 3)}) ${ten.slice(3, 6)}-${ten.slice(6)}`;
}
